let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k90B6")).then(() => parcelRequire('j2Gbi'));